import { memo } from 'react';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import { Checkbox } from '.';

interface CheckboxGroupHookFormProps {
  name: string;
  options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
}

export const CheckboxGroupHookForm = memo<CheckboxGroupHookFormProps>(
  function CheckboxGroupHookForm({ name, options }) {
    const { control } = useFormContext();

    const {
      field: { ref, value, onChange, ...inputProps },
      fieldState,
    } = useController({
      name,
      control,
      defaultValue: [],
    });
    const checkboxIds = useWatch({ control, name: name }) || [];

    const handleChange = (value: any) => {
      const selectedCheckboxIds = checkboxIds;

      if (selectedCheckboxIds.length === 0) {
        selectedCheckboxIds.push(value);
      } else {
        const index = selectedCheckboxIds.findIndex((x: any) => x === value);

        if (index === -1) {
          selectedCheckboxIds.push(value);
        } else {
          selectedCheckboxIds.splice(index, 1);
        }
      }

      onChange(selectedCheckboxIds);
    };

    return (
      <>
        <FormControl>
          <FormGroup>
            {options.map((option) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value.includes(option.value)}
                    {...inputProps}
                    inputRef={ref}
                    onChange={() => handleChange(option.value)}
                    disabled={option?.disabled}
                  />
                }
                label={option.label}
                key={option.value}
              />
            ))}
          </FormGroup>
        </FormControl>

        {Boolean(fieldState.error) && (
          <FormHelperText sx={{ ml: 2 }}>
            {fieldState?.error?.message}
          </FormHelperText>
        )}
      </>
    );
  }
);
